function noop() {
}
function noopValue(value) {
  return value;
}
export {
  noop,
  noopValue
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
